export default __webpack_public_path__ + "static/media/insights_background_left.2fde2fd9.png";